function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#2stars_svg__clip0_1_8)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12.282l-4.945 2.935L4.32 9.608 0 5.813l5.725-.531L8 0l2.274 5.282L16 5.813l-4.32 3.795 1.265 5.61L8 12.281zm2.371-.882v-1.35H8.175c1.494-1.044 2.151-1.827 2.151-2.745 0-1.206-1.017-1.998-2.43-1.998-.837 0-1.79.297-2.43.999l.856 1.026c.431-.405.936-.657 1.601-.657.441 0 .829.216.829.63 0 .594-.487 1.008-3.088 2.889V11.4h4.707z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "2stars_svg__clip0_1_8"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function Svg2Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default Svg2Stars;